module.exports = require("@wildboar/ldap/src/lib/controls");